// 상세 패널 소스별 제안 목록(순수) — 원본·근거·AI·확정이력·유사이력 순.
// 각 소스의 세번·부가설명·채택가능 여부를 계산. 채택/근거상세는 패널이 수행.

/** 세번 정규화 — 숫자만 추출(10자리 HSK). "8544.42.9090"·"8544-42-9090"→"8544429090". */
export function normalizeHsk(v) {
  return String(v ?? "").replace(/\D/g, "");
}

/** 분류 결과 row → 소스별 제안 [{key, label, hsk, note, applicable}]. */
export function buildSourceRows(row) {
  const r = row || {};
  const candCount = Array.isArray(r.topCandidates) ? r.topCandidates.length : 0;
  const evNote = [
    r.evidenceConfidence ? `신뢰도 ${r.evidenceConfidence}` : "",
    candCount ? `후보 ${candCount}건` : "",
  ]
    .filter(Boolean)
    .join("·");
  return [
    {
      key: "origin",
      label: "원본세번",
      hsk: r._originHsk || "",
      note: "인보이스 기재",
      // 원격지 포맷(6/8자리·점표기)은 마스터 오염 방지 위해 채택 불가 — 정규화 10자리만.
      applicable: normalizeHsk(r._originHsk).length === 10,
    },
    {
      key: "evidence",
      label: "근거",
      hsk: r.evidenceHsk || "",
      note: evNote,
      applicable: !!r.evidenceHsk,
    },
    {
      key: "ai",
      label: r.aiModel ? `AI·${r.aiModel}` : "AI",
      hsk: r.geminiHsk || "",
      note: "LLM 판단",
      applicable: !!r.geminiHsk,
    },
    {
      key: "master",
      label: "확정이력",
      hsk: r.masterHsk || "",
      note: r.masterHsk ? "그룹 확정" : "(없음)",
      applicable: !!r.masterHsk,
    },
    {
      key: "similar",
      label: "유사이력",
      hsk: r.simHsk || "",
      note: r.simRate ? `일치율 ${r.simRate}%` : "",
      applicable: !!r.simHsk,
    },
  ];
}
